/**
 * Utility functions for parsing and normalizing agent message content.
 */

export function extractTextContent (content) {
  if (!content) return ''
  if (typeof content === 'string') return content
  if (Array.isArray(content)) {
    return content
      .filter(item => item?.type === 'text')
      .map(item => item?.text || '')
      .join('\n')
  }
  return String(content)
}

export function parseAttachmentNames (content) {
  if (!Array.isArray(content)) return []
  return content
    .filter(item => item?.type === 'text' && item?.text?.includes('<attachment'))
    .map(item => {
      const match = /<attachment[^>]*name="([^"]+)"[^>]*>/.exec(item.text)
      return match ? match[1] : null
    })
    .filter(Boolean)
}

export function stripAttachmentBlocks (text) {
  return text.replace(/<attachment[^>]*>[\s\S]*?<\/attachment>/g, '').trim()
}

export function resolveMessageRole (message) {
  const role = message?.role || (message?.actor === 'agent' ? 'assistant' : message?.actor)
  if (role === 'human') return 'user'
  return role
}

export function isRenderableMessage (message) {
  if (!message) return false
  const role = resolveMessageRole(message)
  return role !== 'tool'
}
